import { render, staticRenderFns } from "./viewPlan.vue?vue&type=template&id=73c8956c&scoped=true&"
import script from "./viewPlan.vue?vue&type=script&lang=js&"
export * from "./viewPlan.vue?vue&type=script&lang=js&"
import style0 from "./viewPlan.vue?vue&type=style&index=0&id=73c8956c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8956c",
  null
  
)

export default component.exports